import React from "react";
import informationIcon from "../../assets/img/Information.svg";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

export default function DropdownTyped({
  answer,
  handleChange,
  question,
  options,
  name,
  error,
  info,
  isMulti = false,
}) {
  const optionsList = options.map((option, index) => ({
    value: option,
    label: option,
  }));
  return (
    <div className="cus_form basic_question_box">
      <div className="custom_filed custom_basic">
        <div className="form-group collection-question">
          <label htmlFor={name} className="basic" style={{ textAlign: "left" }}>
            {question}
            {info && (
              <img
                src={informationIcon}
                alt="Information"
                data-toggle="tooltip"
                data-placement="bottom"
                title={typeof info === "string" ? info : ""}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            )}
          </label>
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti={isMulti}
            options={optionsList}
            isOptionSelected={(option) => answer?.includes(option.value)}
            value={optionsList.filter((option) =>
              answer?.includes(option.value)
            )}
            name={name}
            onChange={(selectedOptions) => {
              const selectedValues = isMulti === true ? selectedOptions?.map(
                (option) => option.value
              ) : [selectedOptions?.value];
              handleChange({
                target: { name, value: selectedValues?.join(",") },
              });
            }}
          />
          {error && (
            <p className="text-danger" style={{ marginTop: "5px" }}>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
